// @ts-nocheck
import Head from 'next/head'


// @ts-ignore
import Hero from "../components/Index/Hero";
import React from "react";


import BaseLayout from "../components/layouts/BaseLayout";
import {getStoryblokApi} from "@storyblok/react";


export async function getStaticProps() {
    let sbParams = {
        version: "published", // or 'published'
    };

    const storyblokApi = getStoryblokApi();
    let navigation = await storyblokApi.get(`cdn/stories/mainnavigation`, sbParams);
    let footer = await storyblokApi.get(`cdn/stories/footer`, sbParams);

    let response = null;
    await fetch("https://www.iubenda.com/api/privacy-policy/98040013")
        .then(res => res.json())
        .then(res => {
            response = res;

        })

    return {
        props: {
            response: response,
            navigation: navigation ? navigation.data.story : false,
            footer: footer ? footer.data.story : false,
        }, // will be passed to the page component as props
    }

}

const Privacy = function (props: any) {

    const metaTitle = 'Privacy Policy - Pacific Codeline LLC';
    const canonical = 'https://www.pacificcodeline.com/privacy';

    return (
        <div className={"bg-warm-gray-50"}>

            <Head>
                <title>{metaTitle}</title>
                <link rel="canonical" href={canonical}/>

                <link rel="icon" href="/favicon.png"/>
            </Head>

            <header>
                {/*<h1>*/}
                {/*    { props.story ? props.story.name : 'My Site' }*/}
                {/*</h1>*/}
            </header>

            <BaseLayout
                navigation={props.navigation}
                footer={props.footer}
            >

                <div className={'max-w-screen-2xl mx-auto rich-text terms py-12 sm:py-24'}>
                    <div dangerouslySetInnerHTML={{__html: props.response.content}}/>
                </div>

            </BaseLayout>
        </div>
    )

}

export default (Privacy)

